export default class BudgetTypeService {

  constructor(server){
    this.server = server;
  }

  list(){
    return this.server("BudgetType.list").then(r => r.result);
  }

  save(item){
    return this.server("BudgetType.create", item);
  }

  update(item){
    return this.server("BudgetType.update", item); 
  }

  remove(item){
    return this.server("BudgetType.delete", {id: item.id});
  }


}


// WEBPACK FOOTER //
// ./src/services/BudgetTypeService.js